import React from 'react';
import {
    Box,
    Typography,
    TextField,
    Grid,
    InputAdornment,
} from '@mui/material';
import { useTranslate } from 'react-admin';
import { OnboardingData } from '../CompanyOnboardingWizard';

interface Props {
    data: OnboardingData;
    updateData: (updates: Partial<OnboardingData>) => void;
    errors: Record<string, string>;
}

export const BrandingStep: React.FC<Props> = ({ data, updateData }) => {
    const translate = useTranslate();

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                {translate('companyOnboarding.steps.brandingTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                {translate('companyOnboarding.steps.brandingDescription')}
            </Typography>

            <Grid container spacing={3}>
                <Grid size={{ xs: 12 }}>
                    <TextField
                        label={translate('companyOnboarding.fields.logoUrl')}
                        value={data.logoUrl}
                        onChange={(e) => updateData({ logoUrl: e.target.value })}
                        fullWidth
                        placeholder="https://cdn.firma.de/logo.png"
                        helperText={translate('companyOnboarding.fields.logoUrlHelp')}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                        label={translate('companyOnboarding.fields.primaryColor')}
                        value={data.primaryColor}
                        onChange={(e) => updateData({ primaryColor: e.target.value })}
                        fullWidth
                        placeholder="#1cab7e"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Box
                                        sx={{
                                            width: 24, height: 24, borderRadius: '4px',
                                            bgcolor: data.primaryColor || 'transparent',
                                            border: '1px solid #ccc',
                                        }}
                                    />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                        label={translate('companyOnboarding.fields.secondaryColor')}
                        value={data.secondaryColor}
                        onChange={(e) => updateData({ secondaryColor: e.target.value })}
                        fullWidth
                        placeholder="#1f3240"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Box
                                        sx={{
                                            width: 24, height: 24, borderRadius: '4px',
                                            bgcolor: data.secondaryColor || 'transparent',
                                            border: '1px solid #ccc',
                                        }}
                                    />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <TextField
                        label={translate('companyOnboarding.fields.faviconUrl')}
                        value={data.faviconUrl}
                        onChange={(e) => updateData({ faviconUrl: e.target.value })}
                        fullWidth
                        placeholder="https://cdn.firma.de/favicon.ico"
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                        label={translate('companyOnboarding.fields.appTitle')}
                        value={data.appTitle}
                        onChange={(e) => updateData({ appTitle: e.target.value })}
                        fullWidth
                        placeholder="Firma Academy"
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                        label={translate('companyOnboarding.fields.poweredByText')}
                        value={data.poweredByText}
                        onChange={(e) => updateData({ poweredByText: e.target.value })}
                        fullWidth
                        placeholder="Powered by online:academy"
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
